// src/Services/countryUtils.js
// Shared utility for country detection and mapping

const COUNTRY_MAP = {
  'NG': 'Nigeria',
  'US': 'United States',
  'GB': 'United Kingdom', 
  'CA': 'Canada',
  'AU': 'Australia',
  'DE': 'Germany',
  'FR': 'France',
  'IN': 'India',
  'BR': 'Brazil',
  'MX': 'Mexico',
  'ZA': 'South Africa',
  'KE': 'Kenya',
  'GH': 'Ghana',
  'EG': 'Egypt',
  'MA': 'Morocco',
  'SG': 'Singapore',
  'MY': 'Malaysia',
  'TH': 'Thailand',
  'PH': 'Philippines',
  'ID': 'Indonesia',
  'VN': 'Vietnam',
  'JP': 'Japan',
  'KR': 'South Korea',
  'CN': 'China',
  'IT': 'Italy',
  'ES': 'Spain',
  'PT': 'Portugal',
  'NL': 'Netherlands',
  'BE': 'Belgium',
  'CH': 'Switzerland',
  'AT': 'Austria',
  'SE': 'Sweden',
  'NO': 'Norway',
  'DK': 'Denmark',
  'FI': 'Finland',
  'IE': 'Ireland',
  'PL': 'Poland',
  'CZ': 'Czech Republic',
  'HU': 'Hungary',
  'RO': 'Romania',
  'BG': 'Bulgaria',
  'GR': 'Greece',
  'TR': 'Turkey',
  'RU': 'Russia',
  'UA': 'Ukraine',
  'AR': 'Argentina',
  'CL': 'Chile',
  'CO': 'Colombia',
  'PE': 'Peru',
  'VE': 'Venezuela',
  'UY': 'Uruguay',
  'PY': 'Paraguay',
  'BO': 'Bolivia',
  'EC': 'Ecuador',
};

const DEFAULT_COUNTRY = 'Nigeria';

// Convert country code to country name
export function getCountryNameFromCode(countryCode) {
  return COUNTRY_MAP[countryCode.toUpperCase()] || DEFAULT_COUNTRY;
}

// Get user's country from browser locale
export async function getUserCountry() {
  try {
    // Try navigator.language first
    const locale = navigator.language || 'en-US';
    const parts = locale.split('-');
    
    if (parts.length > 1) {
      const countryCode = parts[1].toUpperCase();
      return getCountryNameFromCode(countryCode);
    }

    console.warn('Could not detect country from browser locale, using fallback');
    return DEFAULT_COUNTRY;
  } catch (error) {
    console.warn('Country detection failed, using fallback:', error);
    return DEFAULT_COUNTRY;
  }
}

export default {
  getCountryNameFromCode,
  getUserCountry,
  COUNTRY_MAP,
  DEFAULT_COUNTRY
};
